<h1 mat-dialog-title>{{'general.telechargerDossier'|translate}} {{dossier.id}}</h1>
<div mat-dialog-content>
  <div class="row">
    @if (files && files.length) {
      <div class="col-4">
        <p>{{'front.candidature.fichiers'|translate}}</p>
        <mat-checkbox class="mb-2" (change)="addAll($event.checked, 'files')">
          <strong>{{'general.toutSelectionner'|translate}}</strong>
        </mat-checkbox>
        <section class="example-section" style="display: grid;">
          @for (elem of files; track elem) {
            <mat-checkbox [checked]="isSelect(elem, 'files')" class="example-margin"
              (change)="changeElem($event.checked, elem, 'files')">
              {{ (elem.label && elem.label.length) ? elem.label : elem.originalFilename }}
            </mat-checkbox>
          }
        </section>
      </div>
    }

    @if (publications && publications.length) {
      <div class="col-4">
        <p>{{'back.resume.publications'|translate}}</p>
        <mat-checkbox class="mb-2" (change)="addAll($event.checked, 'publications')">
          <strong>{{'general.toutSelectionner'|translate}}</strong>
        </mat-checkbox>
        <section class="example-section" style="display: grid;">
          @for (elem of publications; track elem) {
            <mat-checkbox [checked]="isSelect(elem, 'publications')" class="example-margin"
              (change)="changeElem($event.checked, elem, 'publications')">
              {{ (elem.label && elem.label.length) ? elem.label : elem.originalFilename }}
            </mat-checkbox>
          }
        </section>
      </div>
    }

    @if (annexes && annexes.length) {
      <div class="col-4">
        <p>{{'Annexe'|translate}}</p>
        <mat-checkbox class="mb-2" (change)="addAll($event.checked, 'annexes')">
          <strong>{{'general.toutSelectionner'|translate}}</strong>
        </mat-checkbox>
        <section class="example-section" style="display: grid;">
          @for (elem of annexes; track elem) {
            <mat-checkbox [checked]="isSelect(elem.fichier, 'annexes')"
              class="example-margin" (change)="changeElem($event.checked, elem.fichier, 'annexes')">
              {{ (elem.fichier.label && elem.fichier.label.length) ? elem.fichier.label : elem.fichier.originalFilename }}
            </mat-checkbox>
          }
        </section>
      </div>
    }
  </div>

</div>
<div mat-dialog-actions>
  <button mat-button color="primary" (click)="download()" cdkFocusInitial>{{'general.telecharger'|translate}}</button>
  <button mat-button (click)="onNoClick()">{{'general.annuler'|translate}}</button>
</div>
